module.exports = __webpack_public_path__ + "static/media/buta.c66a8e24.svg";